import { SELECTION_CAP } from 'areas/search/hooks';
import { faShareSquare, faCopy } from '@fortawesome/pro-light-svg-icons';
import { IAction } from './interfaces';
import { AssignCaseworkerOfferDialog } from '../modals/assign-caseworker-dialog/assign-caseworker-offer-dialog';

export const actions: IAction[] = [
  {
    context: 'Offers',
    id: 'OfferAssignTeamOrUser',
    displayName: 'Tildel',
    icon: faShareSquare,
    action: selectedEntries => <AssignCaseworkerOfferDialog offerIds={selectedEntries} />,
    isVisible: selectedItemsCount => selectedItemsCount > 0,
    isDisabled: selectedItemsCount => (selectedItemsCount > SELECTION_CAP ? `Antallet af valgte elementer må ikke overstige ${SELECTION_CAP}` : ''),
  },
  {
    context: 'Offers',
    id: 'CopyOffer',
    displayName: 'Kopiér tilbud',
    action: selectedEntries => {
      window.open(`/offer-and-activity/create-offer?offerId=${selectedEntries[0]}`, '_blank');
    },
    icon: faCopy,
    isVisible: selectedItemsCount => selectedItemsCount > 0,
    isDisabled: selectedItemsCount => (selectedItemsCount > 1 ? 'Antallet af valgte elementer må ikke overstige 1' : ''),
  },
];
